<template>
  <div>
    <AInput v-model="input"
            placehoder="مقدار"
            @change="search"
            @pressEnter="() => search()"
    />
  </div>
</template>

<script>
export default {
  name: 'TextXTableFilter',
  props: ['value'],
  data() {
    return {
      input: undefined
    }
  },
  methods: {
    search() {
      this.$emit('input', this.input)
      this.$emit('search', this.input)
    },
  },
  mounted() {
    this.input = this.value
  }
}
</script>
